var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D8FEE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59961 11.9996C5.59961 8.46499 8.46499 5.59961 11.9996 5.59961C15.5342 5.59961 18.3996 8.46499 18.3996 11.9996C18.3996 15.5342 15.5342 18.3996 11.9996 18.3996C8.46499 18.3996 5.59961 15.5342 5.59961 11.9996ZM14.885 11.119C15.179 10.825 15.179 10.3482 14.885 10.0542C14.5909 9.76015 14.1142 9.76015 13.8201 10.0542L11.2153 12.659L10.1791 11.6228C9.88504 11.3288 9.4083 11.3288 9.11426 11.6228C8.82022 11.9169 8.82022 12.3936 9.11426 12.6876L10.6829 14.2563C10.9769 14.5503 11.4537 14.5503 11.7477 14.2563L14.885 11.119Z",
    fill: "#058521"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.a0b7ab70bed58b6ce36f105941594475.svg";
export { ForwardRef as ReactComponent };